import type {
  AuditLogRepository,
  AuditLogListOptions,
  AuditLogFilters,
  AuditLogPage,
} from '#/domain/audit/AuditLogRepository'
import type { HttpClientPort } from '#/infrastructure/persistence/HttpClientPort'
import { toDomainPage, type AuditLogPageResponseDto } from './AuditLogDto'

export class HttpAuditLogRepository implements AuditLogRepository {
  constructor(private readonly http: HttpClientPort) {}

  async findAll(
    options: AuditLogListOptions,
    filters: AuditLogFilters = {},
  ): Promise<AuditLogPage> {
    const params: Record<string, string> = {
      page: String(options.page),
      itemsPerPage: String(options.itemsPerPage),
    }
    if (filters.organizationId) params.organizationId = filters.organizationId
    if (filters.applicationId) params.applicationId = filters.applicationId
    if (filters.action) params.action = filters.action

    const raw = await this.http.get<AuditLogPageResponseDto>('v1/admin/AuditLog', {
      searchParams: new URLSearchParams(params),
    })
    return toDomainPage(raw)
  }
}
